import React from 'react';
import styled from '../../styles/styled-components';
import { Paper } from '../paper';
import { Button } from '../button';
import { Switch } from '../switch';
import { Menu, MenuItem } from '../menu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/pro-regular-svg-icons';

type HeaderProps = {
  onLogout: () => void;
  onMenuClicked: (ev: React.MouseEvent) => void;
  isSidebarOpen: boolean;
  customerName: string;
  deviceName: string;
} & Stylable;

export const PageHeader: React.SFC<HeaderProps> = ({
  onLogout,
  customerName,
  deviceName,
  onMenuClicked,
  isSidebarOpen,
  ...rest
}) => (
  <PaperContainer {...rest}>
    <HeaderMenu horizontal>
      {isSidebarOpen ? (
        ''
      ) : (
        <MenuButton icon={faBars} onClick={onMenuClicked} />
      )}
      <AssetInfoMenuItem>
        {customerName || 'No customer name'} - {deviceName || 'No device name'}
      </AssetInfoMenuItem>
      <LogoutMenuItem>
        <LogoutButton
          icon="logOut"
          transparent
          content="Disconnect"
          onClick={onLogout}
        />
      </LogoutMenuItem>
    </HeaderMenu>
  </PaperContainer>
);

const PaperContainer = Paper.extend`
  display: flex;
  align-items: center;
  padding: 0;
`;

const HeaderMenu = styled(Menu)`
  flex: 1 0 auto;
  height: 100%;
  margin-left: 22px;
`;

const AssetInfoMenuItem = MenuItem.extend`
  flex: 1 0 auto;
  display: flex;
  align-items: center;
`;

const ToggleMenuItem = MenuItem.extend`
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
`;

const ToggleLabel = styled.label`
  font-weight: normal;
  margin-right: 10px;
  margin-top: 4px;
`;

const StyledSwitch = styled(Switch)``;

const LogoutMenuItem = MenuItem.extend`
  flex: 0 1 auto;
`;

const LogoutButton = styled(Button)`
  height: 100%;
  padding-left: 22px;
  padding-right: 22px;
`;

const MenuButton = styled(FontAwesomeIcon)`
  font-size: 20px;
  cursor: pointer;
  align-self: center;
  margin-right: 10px;
  transition: 0.1s ease all;

  &:hover {
    color: ${p => p.theme.primaryColor};
    transform: scale(1.2);
    transition: 0.1s ease all;
  }
`;
